import * as React from "react";
import Mint from "@/components/organisms/mint";
import MainLayout from "@/components/template/dashboard-layout";
import { useParams, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { CollectionDataCache } from "@/types/collection";
import { backend } from "@/services/backend";
import LoadingStatus from "@/components/atomics/loading-status";
import { loadingData } from "@/data/loading-data";

export default function NFTMintPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [searchParams] = useSearchParams();

  const [collectionInfo, setCollectionInfo] =
    useState<CollectionDataCache | null>(null);
  const { collection } = useParams();

  // Убираем query-параметры из collection
  const cleanCollection = collection?.split("?")[0];

  useEffect(() => {
    const fetchCollectionData = async () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (!cleanCollection) {
        setError(new Error("Collection ID is required"));
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const collectionData = await backend.getCollectionData(cleanCollection);
        setCollectionInfo(collectionData);
      } catch (err) {
        setError(
          err instanceof Error
            ? err
            : new Error("Failed to fetch collection data")
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchCollectionData();
  }, [cleanCollection, searchParams.get("view")]);

  if (!collection) {
    return <div>Collection not found</div>;
  }

  return (
    <MainLayout>
      {isLoading ? (
        <LoadingStatus
          className="bg-black"
          status={loadingData[2].status}
          text={loadingData[2].text}
        />
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : collectionInfo ? (
        <Mint collection={collection} collectionInfo={collectionInfo} />
      ) : (
        <div>No collection data available</div>
      )}
    </MainLayout>
  );
}
